import { defineMessages } from 'react-intl';

export default defineMessages({
  justChecking: {
    id: 'src.pages.PossiblePlacesModal.justChecking',
    defaultMessage: 'Just checking...',
  },
  matchedUp: {
    id: 'src.pages.PossiblePlacesModal.matchedUp',
    defaultMessage: 'We matched up the info you entered with the locations we have on file. Let us know which one we should use.',
  },
  fillInDetails: {
    id: 'src.pages.PossiblePlacesModal.fillInDetails:',
    defaultMessage: 'Fill in a few details to continue.',
  },
  noneOfTheAbove: {
    id: 'src.pages.PossiblePlacesModal.noneOfTheAbove',
    defaultMessage: 'None of the above',
  },
  street: {
    id: 'src.pages.PossiblePlacesModal.street',
    defaultMessage: 'Street #',
  },
  streetName: {
    id: 'src.pages.PossiblePlacesModal.streetName',
    defaultMessage: 'Street Name',
  },
  city: {
    id: 'src.pages.PossiblePlacesModal.city',
    defaultMessage: 'City',
  },
  state: {
    id: 'src.pages.PossiblePlacesModal.state',
    defaultMessage: 'State',
  },
  province: {
    id: 'src.pages.PossiblePlacesModal.province',
    defaultMessage: 'Province',
  },
  country: {
    id: 'src.pages.PossiblePlacesModal.country',
    defaultMessage: 'Country',
  },
  postalCode: {
    id: 'src.pages.PossiblePlacesModal.postalCode',
    defaultMessage: 'Postal Code',
  },
  zipCode: {
    id: 'src.pages.PossiblePlacesModal.zipCode',
    defaultMessage: 'Zip Code',
  },
  saveNewAddress: {
    id: 'src.pages.PossiblePlacesModal.saveNewAddress',
    defaultMessage: 'Save new address',
  },
  continueNewAddress: {
    id: 'src.pages.PossiblePlacesModal.continueNewAddress',
    defaultMessage: 'Continue with new address',
  },
  cancel: {
    id: 'src.pages.PossiblePlacesModal.cancel',
    defaultMessage: 'Cancel',
  },
});
